import { openNotification } from "swfrontend/COMS/NotificationMessageMapping";
import {
  notificationMessage,
  notificationTitle,
  openNotificationType,
} from "swfrontend/MDM/MDMUIConfigs/MDMUIMappings";
import { NOTIFICATIONS } from "../../../constants";

export const Form_Error = (message) => {
  openNotification(openNotificationType.error, notificationTitle.form, message);
};

export const Internal_Server_Error = () => {
  openNotification(
    openNotificationType.error,
    NOTIFICATIONS.ERROR_OCCURED,
    NOTIFICATIONS.REFRESH_PAGE
  );
};

export const Dynamic_Error = (Title, Values) => {
  openNotification(openNotificationType.error, Title, Values);
};
